<div [class.has-insight]="data?.insightName">
  <basic-automation
    *ngIf="!showSuggestions && !data?.insightName"
    [heading]="basicAutomationLocalisationKeys.heading | localize"
    [description]="basicAutomationLocalisationKeys.description | localize"
    (automate)="onAutomate()"></basic-automation>

  <suggested-automation
    *ngIf="showSuggestions && !data?.insightName"
    [suggestedInsights]="suggestedInsights"
    (selectSuggestedInsight)="selectSuggestedInsight($event)"
    (selectSuggestedTemplate)="selectSuggestedTemplate($event)"
    (openBrowseConnectionsModal)="openBrowseConnectionsModal()"></suggested-automation>

  <selected-automation
    *ngIf="data?.insightName"
    [data]="data"
    [confirmedInsight]="confirmedInsight"
    [readonly]="readonly"
    [isEditable]="isEditable()"
    [indicators]="indicators"
    (editFilter)="editInsightFilters()"
    (removeItem)="removeInsightFromItem()"
    (goToInsight)="goToInsight()"
    (openInsight)="openInsight()"></selected-automation>
</div>
